// Vendor Libraries
import { createAction, props } from '@ngrx/store';
export const setPresentationOption = createAction('[Scatter Plot] Set Presentation Option', props());
